import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { axios } from "../common";
export * from "./types";
export var getCodeDetail = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(code) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!code || (code === null || code === void 0 ? void 0 : code.length) !== 5)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            return _context.abrupt("return", axios.get("/referral/code/".concat(code)));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCodeDetail(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var postInvitationCode = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(code, params) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (code) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            return _context2.abrupt("return", axios.post("/referral/code/".concat(code), params));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function postInvitationCode(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var getInvitationCode = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(address) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (address) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            return _context3.abrupt("return", axios.post("/referral/code", {
              address: address
            }));

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getInvitationCode(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var getMyInvitations = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(address) {
    var sort,
        offset,
        limit,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            sort = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 'invited_at';
            offset = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 0;
            limit = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : 10;

            if (address) {
              _context4.next = 5;
              break;
            }

            return _context4.abrupt("return");

          case 5:
            return _context4.abrupt("return", axios.get("/referral/mining/invitations/".concat(address, "?sort=").concat(sort, "&offset=").concat(offset, "&limit=").concat(limit)));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getMyInvitations(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var getMiningRewards = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", axios.get("/referral/mining/pools"));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getMiningRewards() {
    return _ref5.apply(this, arguments);
  };
}();
export var getMyMiningData = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(address) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (address) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return");

          case 2:
            return _context6.abrupt("return", axios.get("/referral/mining/powers/".concat(address)));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getMyMiningData(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var getRoundTradeMining = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(address) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (address) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return");

          case 2:
            return _context7.abrupt("return", axios.get("/referral/mining/rewards/".concat(address)));

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getRoundTradeMining(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
export var getLPs = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", axios.get("/lon-edge/staking/profile"));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getLPs() {
    return _ref8.apply(this, arguments);
  };
}();
export var getRoundTradeMiningReport = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(round) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", axios.get("/referral/lon/trade_mining_report?round=".concat(round)));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getRoundTradeMiningReport(_x8) {
    return _ref9.apply(this, arguments);
  };
}();